var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#1890ff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2370 4734 c-441 -61 -825 -337 -1015 -729 -193 -398 -160 -772 108 -1220 26 -44 108 -165 182 -270 74 -104 164 -233 201 -285 100 -142 227 -358 277 -473 176 -402 343 -984 381 -1327 l12 -105 44 0 44 0 12 105 c38 342 206 926 381 1327 50 115 177 331 277 473 37 52 127 181 201 285 249 353 351 556 394 785 69 366 -66 769 -353 1056 -295 294 -726 437 -1146 378z m331 -770z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMission);
export default __webpack_public_path__ + "static/media/location-mission.362c97087ec22115a4d8555873232f67.svg";
export { ForwardRef as ReactComponent };